import React from 'react';

const Oct8_1989Page = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-calendar-alt"></i>
          October 8, 1989
        </h1>
        <p>A special moment captured in time - reliving the memories of October 8, 1989.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="video-content">
            <p className="welcome-text">
              This date holds special significance, and this video helps tell that story.
              Take a moment to watch and remember this important day in our history.
            </p>

            {/* YouTube Video Embed */}
            <div className="video-container">
              <div className="video-wrapper">
                <iframe
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/OSapzIqJkzc"
                  title="October 8, 1989 - Special Memory"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="date-significance">
              <h3>About This Day</h3>
              <p>
                October 8, 1989 was a meaningful date that deserves to be remembered and shared.
                This video captures the essence of that time and helps preserve these important memories
                for future generations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Oct8_1989Page;